<template>
  <el-form label-position="top" label-width="80px">
    <el-form-item label="搜索">
      <el-input size="mini" style="width:220px;top:2px;" placeholder="姓名或手机号码" v-model="form.key" clearable></el-input>
    </el-form-item>
    <el-form-item label="创建时间">
      <el-date-picker v-model="form.dateRange1" type="daterange" size="mini" range-separator="至"
        start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="datePickerOption"
        value-format="yyyy-MM-dd"></el-date-picker>
    </el-form-item>
    <el-form-item label="客户经理">
      <el-select size="mini" style="width:180px;" multiple v-model="form.member">
        <el-option v-for="item in members" :key="item.memberId" :label="item.userName" :value="item.memberId">
        </el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="订单状态">
      <el-select size="mini" style="width:180px;" multiple v-model="form.orderStatus">
        <el-option v-for="[value, label] in smallOrderStatusMap" :key="value" :label="label" :value="value"></el-option>
      </el-select>
    </el-form-item>
    <!-- <el-form-item label="订购车系">
      <el-select size="mini" style="width:180px;" v-model="form.seriesId" clearable placeholder="请选择车系">
        <el-option v-for="item in seriesList" :key="item.id" :label="item.name" :value="item.id"></el-option>
      </el-select>
    </el-form-item> -->
    <el-form-item label="订购车型">
      <el-cascader
        size="mini"
        class="filter-item"
        style="width: 180px;"
        placeholder="选择订购车型"
        filterable
        collapse-tags
        :props="{ multiple: true }"
        clearable
        :show-all-levels="true"
        :options="carOptions"
        v-model="form.specIds"
      >
      </el-cascader>
    </el-form-item>
    <el-form-item label="APP小订单号">
      <el-input size="mini" style="width:180px;" placeholder="APP小订单号" v-model="form.appSmallOrderId" clearable></el-input>
    </el-form-item>
    <el-form-item label="是否已转大定">
      <el-select size="mini" style="width:180px;" v-model="form.hasTransferOrder" clearable placeholder="请选择">
        <el-option label="是" :value="1"></el-option>
        <el-option label="否" :value="2"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="关联大定订单编号">
      <el-input size="mini" style="width:180px;" placeholder="大定订单编号" v-model="form.relatedOrderId" clearable></el-input>
    </el-form-item>
    <el-form-item label="支付日期">
      <el-date-picker v-model="form.paymentDate" type="daterange" size="mini" range-separator="至"
        start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="datePickerOption"
        value-format="yyyy-MM-dd"></el-date-picker>
    </el-form-item>
    <el-form-item label="交易关闭日期">
      <el-date-picker v-model="form.closeDate" type="daterange" size="mini" range-separator="至"
        start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="datePickerOption"
        value-format="yyyy-MM-dd"></el-date-picker>
    </el-form-item>
  </el-form>
</template>
<script>
import { smallOrderStatusMap, datePickerOption } from '../constants.js'
export default {
  name: 'SmallOrderSearchForm',
  props: {
    form: {
      type: Object,
      default: () => ({})
    },
  },
  model: {
    prop: "form",
    event: "change"
  },
  data() {
    return {
      dealer: this.$common.getLoginInfo().profile,
      datePickerOption,
      members: [],
      seriesList: [],
      carOptions: [],
      // 小订订单状态
      smallOrderStatusMap,
    }
  },
  created() {
    this.retrieveMembers();
    this.retrieveSeries();
    this.retrieveCarOptions();
  },
  methods: {
    retrieveCarOptions() {
      this.$httpAuth
        .post("/v1/dealerRpc/vehicleJsonTree", {
          dealerId: this.dealer.dealerId,
        })
        .then((response) => {
          this.carOptions = response.data.data;
        });
    },
    retrieveMembers() {
      this.$httpAuth
        .post("/v1/dealerMemberRpc/managerMembers", {
          dealerId: this.dealer.dealerId,
        })
        .then((response) => {
          this.members = response.data.data;
        });
    },
    retrieveSeries() {
      this.$httpAuth
        .post("/v1/dealerRpc/seriesList", {
          dealerId: this.dealer.dealerId,
        })
        .then((response) => {
          this.seriesList = response.data.records || [];
        });
    },
  }
}
</script>
<style scoped>
::v-deep .el-form-item {
  margin-bottom: 5px;
}

::v-deep .el-form-item .el-form-item__label {
  line-height: 16px;
  padding-bottom: 3px;
}
</style>
